export default {
  collectOriginInfo() {
    return false;
  }
};